import { FC } from 'react';
import { Checkbox } from '@new/common/ui/Checkbox/Checkbox';
import { cn } from '@new/lib';
import { useUpdateOnboardingMutation } from '@teachur/http-client';
import { useCurrentUser } from '@hooks/users';

const FIELDS = [
  {
    name: 'confirmedAge',
    label: "I verify I'm 18 years of age or older.",
  },
  {
    name: 'confirmedSecondarySchoolCompletion',
    label: 'I verify that I have completed Secondary School\n (high school, GED, or similar).',
  },
  {
    name: 'confirmedMyAddressIsOutside',
    label:
      'I certify that English is my first language OR that I\n speak English at a secondary school level or higher.',
  },
] as const;

export const EligibilityCheckStep: FC = () => {
  const { mutate: updateOnboarding } = useUpdateOnboardingMutation();

  const user = useCurrentUser();
  return (
    <div className="flex flex-col">
      <div className="flex flex-col items-center gap-4 lg:gap-8">
        {FIELDS.map((field) => {
          const checked = user.data?.onboarding?.[field.name] ?? false;
          return (
            <div
              key={field.name}
              className={cn(
                'flex justify-between items-center p-4 lg:pl-8 lg:pr-10 lg:py-[37px] m bg-(--neutral-white-NW800)! w-full',
                'text-start [font-family:var(--font-montserrat)]! text-[10px] lg:[font-size:var(--fs-p3)]!',
                'rounded-md border-2 cursor-pointer transition-colors',
                checked ? 'border-(--neutral-black-NB1000)' : 'border-transparent'
              )}
            >
              <span className="whitespace-pre-line">{field.label}</span>

              <Checkbox
                value={checked}
                onChange={(value) => updateOnboarding({ [field.name]: value })}
                variant="simple"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
